import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Logo_ODD.svg"}/>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    München     </p>
                <p className="ort-subheader">
                </p>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>
        </div>
    )
}

export default Overlay

